import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import FullScreenLoading from "../components/FullScreenLoading";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { cognitoUser, isAuthLoading } = useAuth();
  const location = useLocation();

  // First, check if authentication is still loading
  if (isAuthLoading) {
    // Show loading indicator while checking authentication status
    return <FullScreenLoading />;
  }

  // After loading is complete, if there's no user, redirect to sign-in
  if (!cognitoUser) {
    console.log("No authenticated user found, redirecting to sign-in");
    return <Navigate to="/auth/sign-in" state={{ from: location }} replace />;
  }

  // If we have a user, render the protected content
  return children;
};
